import type { JSX } from "react";
import { scaleBars } from "./geometry";

export function BarChart({ data, height = 120 }: { data: { label: string; value: number }[]; height?: number }): JSX.Element {
  const bars = scaleBars(data.map((d) => d.value), height);
  return (
    <div className="cc-barchart">
      {data.map((d, i) => (
        <div key={d.label} className="cc-barchart-row" title={`${d.label}: ${d.value}`}>
          <span className="cc-barchart-label">{d.label}</span>
          <span className="cc-barchart-track"><span className="cc-barchart-fill" style={{ width: `${(bars[i] ?? 0) / height * 100}%` }} /></span>
          <span className="cc-barchart-value">{d.value}</span>
        </div>
      ))}
    </div>
  );
}
